export const FEATURE_BACKWALLS = (process.env.REACT_APP_ENABLE_BACKWALLS ?? '') === 'on';
export const REACT_APP_DEBUG_BACKWALL = (process.env.REACT_APP_DEBUG_BACKWALL ?? '') === 'on';
export const REACT_APP_DEBUG_CAMERA = (process.env.REACT_APP_DEBUG_CAMERA ?? '') === 'on';